import React from 'react'
import NoRecordsFound from '../components/NoRecordsFound/index'
import Row from '../components/Row/index'

const ClustersList = ({clusters, onAdd, onRemove, selectedDevices, onSort, sortBy, isSortAsc }) => {
    const headers = [
        {
          key: "name",
          name: "Name",
          width: 4
        },
        {
          key: "deviceCount",
          name: "Device Count",
          width: 4,
        },
        {
          key: "actionButton",
          name: "Add / Remove",
          width: 4,
          sortable: false
        }
    ]

    const arrow = isSortAsc ? <span className="glyphicon glyphicon-triangle-top" title="Ascending" /> : <span className="glyphicon glyphicon-triangle-bottom" title="Descending"/>

    const renderTableHeaders = () => {
        return headers.map(({ key, name, width, sortable }) => {
            if (sortable === false) {
                return (
                    <th key={key}>
                        <div className={`text-center table-header col-sm-${width}`}>{name}</div>
                    </th>
                )
            }
    
            return (
                <th key={key}  onClick={() => onSort(key)}>
                    <div className={`text-center table-header table-header-clickable col-sm-${width} flex-center`} >
                        {name} {sortBy === key && arrow }
                    </div>
                </th>
            )
        })
    }

    const renderTableRows = () => {
        if (clusters.length) {
            return clusters.map(cluster => {
                const isClusterSelected = cluster.devices.every(deviceId => selectedDevices.find(({ _id }) => deviceId === _id));
                const addButton = <a className="cluster-add" ><span className="glyphicon glyphicon-plus add-button" /></a>
                const removeButton = <a className="cluster-add"><span className="glyphicon glyphicon-minus red" /></a>

                const selectedFields = {
                    name: cluster.name,
                    deviceCount: cluster.devices.length || 0,
                    actionButton: isClusterSelected ? removeButton : addButton
                }

                return (
                    <Row
                        key={cluster._id} 
                        data={selectedFields}
                        onClick={isClusterSelected ? () => onRemove(cluster) : () => onAdd(cluster)}
                    />
                )
            })
        }

        return <NoRecordsFound />
    }

    return (
    <div className="test-instance-list">
        <table className="table">
            <thead className="test-instance-details-head">
                <tr>{ renderTableHeaders() }</tr>
            </thead>
            <tbody>
                { renderTableRows() }
            </tbody>
        </table>
    </div>)
}

export default ClustersList